import React from "react";
import styles from "./WhatIsgdg.module.css";
import { useColorModeValue } from "../../hooks/useColorModeValue.js";
import gdg from "../../assets/community/GDG.jpg"
import { ReactComponent as BgSvg } from "../../assets/whatIsgdg/bg.svg";
import { Cloud3 } from "../../assets/whatIsgdg/cloud3.js";
import { Bottom3 } from "../../assets/whatIsgdg/bottom3.js";
import { Bottom2 } from "../../assets/whatIsgdg/bottom2.js";

const WhatIsgdg = () => {
  return (
    <div
      className={styles.container}
      style={{ background: useColorModeValue("#202124", "#202124") }}
      id="what-is-gdgc"
    >
      <div className={styles.headingWrapper}>
        <div className={styles.heading}>
          <div
            data-aos="fade-up-right"
            data-aos-duration="1500"
            className={styles.cloudContainer}
          >
            <Cloud3
              color={useColorModeValue("#ffffff", "#ffffff")}
              className={styles.cloud3}
            />
          </div>
          <div
            className={styles.headText}
            style={{ color: useColorModeValue("#ffffff", "#ffffff") }}
          >
            What is GDGoC ?
          </div>
        </div>
      </div>
      <div className={styles.gdgszabistBodyContainer}>
        <div className={styles.image}>
          <div className={styles.imgWrapper}>
            <div className={styles.imgContainer}>
              <img
                src={gdg}
                width={375}
                alt="What is GDGoC SZABIST Karachi?"
              ></img>
            </div>
            <div
              data-aos="fade-up-right"
              data-aos-duration="1000"
              className={styles.svgContainer}
            >
              <BgSvg />
            </div>
          </div>
        </div>
        <div
          className={styles.bodyText}
          style={{ color: useColorModeValue("#ffffff", "#ffffff") }}
        >
          <strong>GDG on Campus SZABIST</strong> is a community-driven initiative that fosters technology and innovation among students. Hosted by Google Developer Groups, we focus on knowledge exchange, networking, and hands-on learning about Google technologies to support the local developer community. Join us to enhance your skills and connect with industry professionals!
        </div>
      <div className={styles.bottomContainer}>
        <span
          data-aos="slide-right"
          data-aos-offset="-50"
          data-aos-duration="3000"
        >
          <Bottom2 color={useColorModeValue("#E8EAED", "#E8EAED")} />
        </span>
        <span data-aos="fade-up" data-aos-duration="1500">
          <Bottom3
            color={useColorModeValue("#E8EAED", "#E8EAED")}
            className={styles.bottom3}
          />
        </span>
      </div>
    </div>

   </div>
  );
};

export default WhatIsgdg;
